import React from 'react';
import { Spin } from 'antd';
import Chart from 'react-apexcharts';

const BarChart = ({ data, valueType, isLoading, height, opposite }) => {
  const indicatorColor = data.map((_item) => '#1E8449');
  const series = [{ data: data?.map((item) => item.value) }];

  const options = {
    chart: {
      id: 'bar-chart',
      toolbar: {
        show: false,
      },
      type: 'bar',
    },
    colors: indicatorColor,
    fill: {
      type: 'solid',
    },
    xaxis: {
      categories: data?.map((item) => item?.month ? [item.name, item.month] : item.name),
      tickPlacement: 'on',
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
    },
    plotOptions: {
      bar: {
        horizontal: false,
        distributed: true,
      },
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      offsetY: -30,
    },
    tooltip: {
      enabled: true,
      enabledOnSeries: undefined,
      shared: true,
      y: {
        formatter: function (value) {
          return value + `${valueType === 'percentage' ? '%' : ''}`;
        },
      },
    },
    yaxis: {
      opposite,
      title: {
        text: valueType === 'percentage' ? 'Percent' : 'Index',
        rotate: -90,
        offsetX: 0,
        offsetY: 0,
        style: {
          color: '#454545',
          fontSize: '12px',
          fontWeight: 600,
        },
      },
    },
  };

  //Please remove the spinner if you don't need it.
  return (
    <Spin spinning={isLoading}>
      <Chart
        options={options}
        series={series}
        type="bar"
        width={'100%'}
        height={height}
      />
    </Spin>
  );
};

// BarChart.propTypes = {
//   data: PropTypes.arrayOf(
//     PropTypes.shape({
//       name: PropTypes.string.isRequired,
//       value: PropTypes.number.isRequired,
//     }),
//   ),
//   valueType: PropTypes.oneOf(['number', 'percentage']),
//   isLoading: PropTypes.bool,
//   height: PropTypes.number,
//   opposite: PropTypes.bool,
// };

BarChart.defaultProps = {
  height: 320,
  opposite: false,
};

export default React.memo(BarChart);
